import React from 'react';

const ResponsiveImage = ({ image, maxWidth, title, className }) => {
  if (!image) {
    return null;
  }

  let srcsetWidths = [200, 400, 600, 800, 1200, 1500, 1900, 2400];

  return (
    <img
      src={`${image}`}
      srcSet={srcsetWidths.filter((w) => w <= parseInt(maxWidth)).map((w) => `${image}&width=${w} ${w}w,`)}
      width={image.width}
      height={image.height}
      alt={title}
      loading="lazy"
      className={className ? className : ''}
    ></img>
  );
};

export default ResponsiveImage;
